<template>
  <div v-if="isexist" :class="['toolbar', `${request_prefix}-toolbar`]" :style="computedStyle" @mousedown.stop>
    <div v-if="!options.hideToolTipHeader" class="toolbar-header">
      <span v-show="checkOptName" @click="backTopTitle" class="back_icon icon-portal-arrows-left"></span>
      {{ toolbarHeaderName }}
    </div>
    <el-tabs v-if="child_options" ref="toolbarTabs" v-model="activeName" :disabled="ids === null" @tab-click="handleClick">
      <el-tab-pane v-if="!alignHelperStatus && options.onlyShowSet && options.name" name="first">
        <component
          v-if="!alignHelperStatus && options.onlyShowSet && tabShow.first"
          :is="options.name + 'Setting'"
          :options="child_options"
          :container_id="container_id"
          :rect_id="rect_id"
          activeType="1"
        ></component>
      </el-tab-pane>
      <el-tab-pane
        v-if="elementActive && !alignHelperStatus && !options.onlyShowSet && options.name"
        :label="request_prefix === 'bigScreen' ? '样式' : '设置'"
        :name="options.onlyShowSet ? 'second' : 'first'"
      >
        <!--<align-helper />-->
        <cx-slider
          class="rect-active-slider"
          v-if="showActiveType"
          label="状态"
          :value.sync="activeType"
          :options="currentActiveTypeOptions"
        />
        <div
          v-if="showActiveType && activeType === '3' && options.name !== 'navMenuVerticalComponent'"
          class="hover-same-active"
        >
          <el-checkbox v-model="hoverIsSameActive">同选中状态</el-checkbox>
        </div>
        <el-collapse v-if="options.onlyShowSet ? tabShow.second : tabShow.first" v-model="activeNames">
          <el-collapse-item
            v-if="
              !options.hasNoStyle &&
              options.name !== 'colsComponentBigScreen' &&
              options.name !== 'layoutComponentBigScreen' &&
              options.name !== 'digitRollComponent' &&
              !checkOptName &&
              (!showActiveType || activeType === '1') &&
              styleOpened
            "
            @mousedown.native="collapseMouseDown($event, '1')"
            title="选择样式"
            name="1"
            class="paddingb_4"
          >
            <template slot="title">
              选择样式
              <span class="stop-blank" @click.stop></span>
              <div
                class="more-btn"
                @click.stop="moreClick()"
                v-if="child_options && (child_options.isSystemComponent || options.showProductStyle)"
              >
                更多<i class="icon-portal-arrows-right"></i>
              </div>
            </template>
            <template v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
              <!--产品组合的组件-->
              <product-component-style
                v-if="
                  (child_options.isSystemComponent && child_options.isIndependenceComponent) || options.showProductStyle
                "
                class="template-styles"
                :options="child_options"
                :styleOptions="options"
                :container_id="container_id"
                :rect_id="rect_id"
                @changeOption="getNewOptions"
                ref="localStyleComponent"
              />
              <!--原生组件-->
              <component
                v-else
                class="template-styles"
                :id="options.name + 'Style'"
                :is="options.name + 'Style'"
                :options="child_options"
                :container_id="container_id"
                :rect_id="rect_id"
                @changeOption="getNewOptions"
                ref="localStyleComponent"
              ></component>
            </template>
          </el-collapse-item>
          <component
            :id="options.name + 'Setting'"
            :is="options.name + 'Setting'"
            :options="child_options"
            :container_id="container_id"
            :rect_id="rect_id"
            :activeType="activeType"
            :styleOpened.sync="styleOpened"
            ref="setComponent"
          ></component>
          <el-collapse-item
            v-if="request_prefix !== 'bigScreen'"
            @mousedown.native="collapseMouseDown($event, '2')"
            title="动画设置"
            name="2"
          >
            <component
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
              :is="'animateSet'"
              :options="child_options"
              :container_id="container_id"
              :rect_id="rect_id"
            ></component>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane label="设置" v-if="options.showConfig && !isLoginLayout && !isLoginName && options.name" name="fifth">
        <component
          v-if="tabShow.fifth"
          :is="options.name + 'Config'"
          :options="child_options"
          :container_id="container_id"
          :rect_id="rect_id"
        ></component>
      </el-tab-pane>
      <el-tab-pane
        v-if="
          elementActive &&
          !alignHelperStatus &&
          !options.onlyShowSet &&
          !options.onlyShowBaseSet &&
          !child_options.disableSetData &&
          options.name &&
          !options.hasNoData
        "
        :label="isLoginLayout ? '设置' : '数据'"
        :name="options.onlyShowSet ? 'third' : 'second'"
      >
        <!-- v-show:同步单元格时需要手动掉一次查看数据响应，用的模拟点击 v-if找不到按钮-->
        <component
          v-show="options.onlyShowSet ? tabShow.third : tabShow.second"
          :is="options.name + 'Data'"
          :options="child_options"
          :container_id="container_id"
          :rect_id="rect_id"
        ></component>
      </el-tab-pane>
      <el-tab-pane
        label="交互"
        v-if="elementActive && !alignHelperStatus && !options.onlyShowSet"
        :name="options.onlyShowSet ? 'fourth' : 'third'"
      >
        <bindEvent v-if="options.onlyShowSet ? tabShow.fourth : tabShow.third" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import "assets/css/options.css"
import {
  handleFindLayoutComponentOptions,
  handleFindLayoutComponentOptionsCols,
  getAllElementsInColsInLayoutComponent
} from "../../../utils/index.js"
import componentsMixIn from "./toolBarMixIn.js"
import { toolbarMixins } from "core/materialLoader"
export default {
  mixins: [componentsMixIn],
  data() {
    return {
      activeNames: ["1"],
      collapseActiveNames: ["1"],
      tabShow: {
        first: true,
        second: false,
        third: false,
        fourth: false,
        fifth: false
      },
      // dialogVisible: false,
      activeName: "first",
      options: {},
      container_id: null,
      rect_id: null,
      screenW: window.screen.width,
      screenH: window.screen.height,
      computedStyle: {
        right: 0,
        top: "10vh"
      },
      startPosition: {},
      deepTitleName: "",
      ids: null,
      changeElementType: true, //控制toolbar只有在组件类型发生改变时才会更新，避免事件操作时触发toolbar更新
      parentElementType: "",
      currentActiveTypeOptions: [],
      activeType: "1",
      activeTypeOptions: [
        { value: "1", title: "默认" },
        { value: "2", title: "选中" },
        { value: "3", title: "悬浮" }
      ],
      // 样式显示状态，可由子组件调整
      styleOpened: true
    }
  },
  watch: {
    isexist() {
      if (this.isexist) {
        Object.keys(this.tabShow).some((k, i) => {
          if (i === 0) {
            this.$set(this.tabShow, k, true)
          } else {
            this.$set(this.tabShow, k, false)
          }
        })
        this.activeName = "first"
      }
    },
    "$store.state.states.elementType"(n, o) {
      const map3DSubSettings = ["cxMap3DHot", "cxMap3DBar", "cxMap3DLines", "cxMap3DScatter"]
      this.parentElementType = map3DSubSettings.includes(n) ? "cxMap3D" : ""
      this.changeElementType = true
      this.tabShow = {
        first: true,
        second: false,
        third: false,
        fourth: false,
        fifth: false
      }
      this.getOptions()
    },
    "$store.state.states.activeID": {
      deep: true,
      immediate: true,
      handler(n, o) {
        if (n !== 0) {
          this.activeType = "1"
          this.getChildDataStatus()
        }
        if (this.changeElementType) {
          this.getIds()
        }
        this.changeElementType = false
      }
    },
    "options.name": {
      deep: true,
      immediate: true,
      handler(n, o) {
        // 自由布局在调整内容后，数据配置始终激活，方便在改变单元格后更新数据
        if (n === "layoutComponentBigScreen") {
          this.tabShow.second = "true"
        }
      }
    },
    "child_options.quoteFrom": {
      deep: true,
      immediate: true,
      handler(n, o) {
        // 自由布局在调整内容后，数据配置始终激活，方便在改变单元格后更新数据
        if (n || o) {
          this.getOptions()
        }
      }
    },
    "child_options.disableSetColAndRow": {
      deep: true,
      immediate: true,
      handler(n, o) {
        // 编组的自由布局和普通的自由布局，切换时更新配置
        if ((n || o) && n !== o) {
          this.getOptions()
        }
      }
    }
  },
  computed: {
    toolbarHeaderName() {
      if (this.child_options?.isSystemComponent && this.child_options?.isIndependenceComponent) {
        return this.child_options.name || this.child_options.menuName || this.options?.lable
      } else if (this.child_options?.isCustomComponent) {
        return this.child_options.name
      } else {
        if (this.child_options?.pluginName && this.child_options?.pluginName[0] == "loginLayoutComponent") {
          return "登录"
        } else {
          return this.options?.lable || ""
        }
      }
    },
    isLoginLayout() {
      if (this.child_options?.pluginName && this.child_options?.pluginName[0] == "loginLayoutComponent") {
        return true
      } else {
        return false
      }
    },
    isLoginName() {
      if (this.child_options?.loginType === "loginName") {
        return true
      } else {
        return false
      }
    },
    checkOptName() {
      return (
        (this.options?.name?.includes("realMap") && this.options.name !== "realMapComponent") || this.parentElementType
      )
    },
    alignHelperStatus() {
      return this.$store.state.states.alignHelperStatus
    },
    isLayout() {
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
    isexist() {
      if (
        this.request_prefix === "bigScreen" ||
        this.request_prefix === "stage" ||
        this.request_prefix === "appStage"
      ) {
        return true
      }
      return this.$store.state.states.toolBarStatus
    },
    elementActive() {
      return this.$store.state.states.elementType
    },
    child_options() {
      const ids = this.$store.state.states.activeID
      const stage = this.$store.state[this.request_prefix]
      if (ids.pageLayoutId !== null && typeof ids.pageLayoutId !== "undefined") {
        return this.getAttrById(stage, { pageLayoutId: ids.pageLayoutId }, "pageLayout")
      }
      if (ids.container_id === null || typeof ids.container_id === "undefined") {
        return ""
      } else if (ids.rect_id === null || typeof ids.rect_id === "undefined") {
        //返回画布数据
        this.getRectAttribute.call(this, ids)
        return this.getAttrById(stage, { container_id: ids.container_id }, "container")?.options
      } else if (typeof ids.elementInSwiperId === "number") {
        //返回轮播内的组件的数据
        return this.getAttrById(stage, ids, "elementInSwiper")
      } else if (ids.directionIndex != null) {
        //自由布局里面的title部分
        return this.getAttrById(stage, ids, "rect").options.titleOptions[ids.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === ids.elementInLayoutId
        ).options
      } else if (ids.uid === null || typeof ids.uid === "undefined") {
        //返回普通组件的数据
        console.log(this.getRectAttribute.call(this, ids).options)
        return this.getRectAttribute.call(this, ids).options
      } else {
        //返回自由布局组件内的数据
        const pOptions = this.getRectAttribute.call(this, ids).options.rows
        const uid = ids.uid
        if (
          Object.keys(this.options).length !== 0 &&
          this.options.name !== "emptyLayoutComponent" &&
          this.options.name !== "layoutComponentBigScreen"
        ) {
          if (this.options.name === "colsComponentBigScreen") {
            let res = handleFindLayoutComponentOptionsCols(pOptions, uid)
            return res
          } else {
            let result = handleFindLayoutComponentOptions(pOptions, uid)
            return result.find(it => it.elementInLayoutId === ids.elementInLayoutId)
          }
        } else {
          return null
        }
      }
    },
    showActiveType() {
      if (["cxTabs", "cxRadio"].includes(this.child_options?.innerElement)) {
        this.currentActiveTypeOptions = this.activeTypeOptions.filter(option => option.value !== "3")
      } else {
        this.currentActiveTypeOptions = this.activeTypeOptions
      }
      return (
        // ["cxNavMenu", "cxNavMenuVertical", "cxBreadCrumbs", "cxTabs", "cxPagination", "cxRadio"].includes(
        //   this.child_options?.innerElement
        // ) && this.request_prefix !== "bigScreen"
        ["cxNavMenu", "cxNavMenuVertical", "cxBreadCrumbs", "cxPagination", "cxRadio"].includes(
          this.child_options?.innerElement
        )
      )
    },
    hoverIsSameActive: {
      get() {
        return this.child_options.hoverIsSameActive
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIsSameActive", false)
      }
    }
  },

  methods: {
    initTabShow() {
      this.tabShow = {
        first: true,
        second: false,
        third: false,
        fourth: false,
        fifth: false
      }
    },
    getIds() {
      let ids = this.$store.state.states.activeID
      //初始化显示哪个tab
      this.initTabShow()
      this.getOptions()
      // 解决第一个画布已经删除后，没有container_id为0情况
      let containers = this.$store.state[this.request_prefix].page.children
      let idsInContainers = false
      for (let i = 0; i < containers.length; i++) {
        if (containers[i].container_id === ids.container_id) {
          idsInContainers = true
          break
        }
      }
      if (!idsInContainers) {
        ids = {
          ...ids,
          container_id: containers[0].container_id
        }
        this.$store.commit("states/changeActiveID", ids)
        this.$store.dispatch(this.request_prefix + "/setContainerActive", ids)
      }
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        this.ids = idsInContainers ? this.$store.state.states.activeID : ids
      } else this.ids = null
    },
    backTopTitle() {
      this.$store.commit("states/changeElementType", this.parentElementType || "cxRealMap")
      this.initTabShow()
    },
    getNewOptions() {
      if (this.$refs.setComponent.getOptionsHandle && typeof this.$refs.setComponent.getOptionsHandle === "function") {
        this.$refs.setComponent.getOptionsHandle("changeStyle")
      }
    },
    // 滚动右侧工具栏页面  关闭下拉弹框
    scrollToolbar() {
      let selectDropdown = document.getElementsByClassName("toolbar")[0].getElementsByClassName("el-input")
      for (let i = 0; i < selectDropdown.length; i++) {
        if (selectDropdown[i].classList.value.indexOf("is-focus") > -1) {
          selectDropdown[i].click()
        }
      }
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    closeEdit() {
      this.$store.commit("states/changeToolBarStatus", false)
      this.$store.commit("states/changeAlignHelperStatus", false)
    },
    handleClick(tab) {
      Object.keys(this.tabShow).forEach(k => {
        // 自由布局在调整内容后，数据配置始终激活，方便在改变单元格后更新数据
        if (k === tab.name || tab.label === "数据") {
          this.$set(this.tabShow, k, true)
        } else {
          this.$set(this.tabShow, k, false)
        }
      })
      if(tab.label === "数据") {
        this.$eventBus.$emit("update-toolbar-data")
      }
    },
    getOptions() {
      let elementType = this.$store.state.states.elementType
        ? this.$store.state.states.elementType
        : this.request_prefix === "bigScreen"
        ? this.request_prefix + "Container"
        : null
      console.log("elementType", elementType)
      let result = {}
      switch (elementType) {
        case "swiperComponent":
          result.name = elementType
          result.lable = "轮播"
          result.showConfig = true
          break
        case "cxText":
          result.name = "textComponent"
          result.lable = "文本"
          break
        case "cxTabs":
          if (this.child_options.quoteFrom === "cxSelect") {
            result.name = "selectComponent"
          } else {
            result.name = "tabsComponent"
          }
          result.lable = "标签页"
          // result.onlyShowBaseSet = true
          // result.hasNoStyle = true
          result.hasNoEvent = true
          result.hasNoData = true
          result.showConfig = true
          break
        case "cxPagination":
          result.name = "paginationComponent"
          result.lable = "分页"
          // result.onlyShowSet = true
          result.hasNoStyle = true
          result.hasNoData = true
          break
        case "imageComponent":
          result.name = "imageComponent"
          result.lable = "图片"
          result.hasNoStyle = true
          break
        case "cxButton":
          result.name = "buttonComponent"
          result.lable = "按钮"
          result.hasNoStyle = true
          break
        case "cxLabel":
          result.name = "labelComponent"
          result.lable = "状态标签"
          result.showConfig = true
          result.hasNoStyle = true
          break
        case "cxShape":
          result.name = "shapeComponent"
          result.lable = "形状"
          result.onlyShowBaseSet = true
          break
        case "cxBorder":
          result.name = "borderComponent"
          result.lable = "边框"
          result.onlyShowBaseSet = true
          break
        case "cxAnimate":
          result.name = "animateComponent"
          result.lable = "动画装饰"
          result.onlyShowBaseSet = true
          break
        case "layoutComponentBigScreen":
          // if (this.$store.state.states.activeID.uid) {
          //   result.name = "colsComponent"
          //   result.lable = "自由布局"
          // } else {
          // result.name = "emptyLayoutComponentBigScreen"
          result.name = "layoutComponentBigScreen"
          result.lable = "自由布局"
          // result.hasNoStyle = true
          result.showConfig = true
          // }
          if (this.child_options && !this.child_options?.isSystemComponent) {
            result.hasNoStyle = true
          }
          if (this.child_options.disableSetColAndRow) {
            result.lable = "画框"
            result.showConfig = false
            this.child_options.disableSetData = true
          }
          break
        // case "layoutComponent":
        //   result.name = "layoutComponentBigScreen"
        //   result.lable = "布局"
        //   result.showConfig = true
        //   break
        case "emptyLayoutComponent":
          /* 排查自由布局的数据类型为emptyLayoutComponent，此数据为大屏和门户首页自由布局类型未区分时的旧数据 */
          // result.name = "emptyLayoutComponent"
          result.name = "emptyLayoutComponentBigScreen"
          result.lable = "自由布局"
          result.showConfig = true
          if (this.child_options && !this.child_options?.isSystemComponent) {
            result.hasNoStyle = true
          }
          if (
            this.child_options?.hasOwnProperty("pluginName") &&
            this.child_options?.pluginName.indexOf("loginLayoutComponent") > -1
          ) {
            // 登录组件
            result.hasNoStyle = false
          }
          break
        case "cxPageLayout":
          result.name = "pageLayoutComponent"
          result.lable = "通栏"
          if (this.child_options.options.inDocument === "header") {
            result.lable = "头部"
          } else if (this.child_options.options.inDocument === "footer") {
            result.lable = "底部"
          }
          result.onlyShowSet = true
          result.hideToolTipHeader = true
          break
        case "cxPageLayoutCell":
          result.name = "cellLayoutComponent"
          result.lable = "布局"
          result.onlyShowSet = true
          break
        case "colsComponent":
          result.name = "colsComponentBigScreen"
          result.lable = "单元格"
          break
        case "container":
          if (this.isLayout) {
            result.name = "page"
            result.lable = "页面"
          } else {
            result.name = this.request_prefix === "bigScreen" ? "bigScreenContainer" : "container"
            result.lable = "画布"
          }
          result.onlyShowSet = true
          break
        case "bigScreenContainer":
          if (this.isLayout) {
            result.name = "page"
            result.lable = "页面"
          } else {
            result.lable = "画布"
            result.onlyShowSet = true
          }
          break
        case "cxNavMenu":
          result.name = "navMenuComponent"
          result.lable = "多级菜单"
          this.hasNoStyle = true
          break
        case "cxNavMenuVertical":
          result.name = "navMenuVerticalComponent"
          result.lable = "树形菜单"
          result.hasNoStyle = true
          break
        case "cxMore":
          result.name = "moreComponent"
          result.lable = "更多"
          break
        case "cxBar":
          result.name = "barComponent"
          result.lable = "柱状图"
          break
        case "cxLiquidFill":
          result.name = "liquidFillComponent"
          result.lable = "水位图"
          break
        case "cxGauge":
          result.name = "gaugeComponent"
          result.lable = "仪表盘"
          break
        case "cxPie":
          result.name = "pieComponent"
          result.lable = "饼图"
          break
        case "cxPie3D":
          result.name = "pie3DComponent"
          result.lable = "3D饼图"
          break
        case "cxRadar":
          result.name = "radarComponent"
          result.lable = "雷达图"
          break
        case "cxLine":
          result.name = "lineComponent"
          result.lable = "折线图"
          break
        case "cxMap":
          result.name = "mapComponent"
          result.lable = "3D地球"
          result.hasNoStyle = true
          break
        // case "cxMap3D":
        //   result.name = "map3DComponent"
        //   result.lable = "3D地图"
        //   break
        // case "cxMap3DScatter":
        //   result.name = "map3DScatterComponent"
        //   result.lable = "散点/气泡层"
        //   break
        // case "cxMap3DHot":
        //   result.name = "map3DHotComponent"
        //   result.lable = "区域热力层"
        //   break
        // case "cxMap3DLines":
        //   result.name = "map3DLinesComponent"
        //   result.lable = "飞线层"
        //   break
        // case "cxMap3DBar":
        //   result.name = "map3DBarComponent"
        //   result.lable = "柱状层"
        //   break
        case "cxRealMap":
          result.name = "realMapComponent"
          result.lable = "地图"
          break
        case "cxRealMapScatter":
          result.name = "realMapScatterComponent"
          result.lable = "涟漪图"
          break
        case "cxRealMapHot":
          result.name = "realMapHotComponent"
          result.lable = "区域热力图"
          break
        case "cxRealMapLines":
          result.name = "realMapLinesComponent"
          result.lable = "飞线层"
          break
        case "cxCloud":
          result.name = "cloudComponent"
          result.lable = "词云"
          break
        case "cxWeather":
          result.name = "weatherComponent"
          result.lable = "天气"
          result.onlyShowBaseSet = true
          break
        case "cxDate":
          result.name = "dateComponent"
          result.lable = "日期"
          result.onlyShowBaseSet = true
          break

        case "cxTable":
          result.name = "tableComponent"
          result.lable = "表格"
          result.showConfig = true
          break
        case "cxDigitRoll":
          result.name = "digitRollComponent"
          result.lable = "数字滚动"
          break
        case "cxVideo":
          result.name = "videoComponent"
          result.lable = "视频"
          break
        case "cxIframe":
          result.name = "iframeComponent"
          result.lable = "内嵌网页"
          // result.onlyShowBaseSet = true
          break
        case "page":
          result.name = "page"
          result.lable = "页面"
          result.onlyShowSet = true
          break
        case "cxReturn":
          result.name = "returnComponent"
          result.lable = "返回"
          result.onlyShowBaseSet = true
          result.hasNoStyle = true
          break
        case "cxSelect":
          if (this.child_options?.quoteFrom && this.child_options.quoteFrom === "cxTabs") {
            // result.name = "tabsComponent"
            result.lable = "标签页"
          } else {
            result.lable = "下拉框"
            result.hasNoStyle = true
          }
          result.name = "selectComponent"
          break
        case "cxDatePicker":
          result.name = "datePickerComponent"
          result.lable = "时间选择器"
          result.onlyShowBaseSet = true
          break
        case "cxCamera":
          result.name = "cameraComponent"
          result.lable = "监控"
          break
        case "cxIcon":
          result.name = "iconComponent"
          result.lable = "图标"
          result.hasNoStyle = true
          result.onlyShowBaseSet = true
          break
        case "cxPictorialBar":
          result.name = "pictorialBarComponent"
          result.lable = "象形柱图"
          break
        case "cxCode":
          result.name = "codeComponent"
          result.lable = "二维码"
          result.hasNoStyle = true
          result.showConfig = false
          break
        case "cxDanmaku":
          result.name = "danmaku"
          result.lable = "滚动词云"
          result.hasNoStyle = true
          result.showConfig = true
          break
        default: {
          const menuConfig = toolbarMixins.menuConfig[elementType]
          if (menuConfig) {
            result.name = menuConfig.name
            result.lable = menuConfig.label
            this.parentElementType = menuConfig.parentMenuName || ""
          }
        }
      }
      if ((this.request_prefix === "bigScreen" && elementType === null) || elementType === "bigScreenContainer") {
        if (this.isLayout) {
          result.name = "page"
          result.lable = "页面"
          result.onlyShowSet = true
        } else {
          result.name = "bigScreenContainer"
          result.lable = "画布"
          result.onlyShowSet = true
        }
      }
      if ((this.request_prefix !== "bigScreen" && elementType === null) || elementType === "page") {
        // result.name = "global"
        result.name = "page"
        result.lable = "页面"
        result.onlyShowSet = true
        const oldIds = { ...this.$store.state.states.activeID }
        delete oldIds.container_id
        if (Object.values(oldIds).some(item => item !== null)) {
          const ids = {}
          for (let k in oldIds) {
            ids[k] = null
          }
          oldIds.container_id = this.$store.state.states.activeID.container_id
          this.$store.commit("states/changeActiveID", ids)
        }
      }
      this.getChildDataStatus()
      this.activeName = "first"
      this.options = result
    },
    moreClick() {
      this.$refs.localStyleComponent.showAllStyles()
    },
    /*  当自由布局外接数据源后，屏蔽里面所有组件的外接数据源入口
            当自由布局里某个组件外接数据源后，屏蔽自由布局本身的外接数据源入口
         */
    getChildDataStatus() {
      let newIds = JSON.parse(JSON.stringify(this.ids))
      if (this.child_options && this.child_options.hasOwnProperty("elementInLayoutId")) {
        let parentAttr = this.getRectAttribute.call(this, {
          container_id: newIds.container_id,
          rect_id: newIds.rect_id
        }).options
        // if (parentAttr.noCacheComponent) {
        //   this.child_options.disableSetData = true
        // }else{
        //   this.child_options.disableSetData = false
        // }
        // 产品提的 大屏不需要隐藏自由布局下的基础组件的数据设置和2.0同步
        if (this.child_options.disableSetData) {
          this.child_options.disableSetData = false
        }
      } else if (this.child_options && this.child_options.innerElement === "emptyLayoutComponent") {
        const allElementInLayout = getAllElementsInColsInLayoutComponent(this.child_options.rows)
        if (Object.keys(allElementInLayout).length > 0) {
          let childIsnoCacheComponent = false
          for (let key in allElementInLayout) {
            if (allElementInLayout[key] && allElementInLayout[key].elementOptions.length > 0) {
              let list = allElementInLayout[key].elementOptions
              for (let i = 0; i < list.length; i++) {
                if (list[i] && list[i].noCacheComponent && list[i].appId) {
                  this.child_options.disableSetData = true
                  childIsnoCacheComponent = true
                  break
                }
              }
            }
            if (childIsnoCacheComponent) {
              break
            }
          }
          if (!childIsnoCacheComponent) {
            this.child_options.disableSetData = false
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.hide_Header/deep/ > .el-tabs__header {
  display: none;
}
.toolbar .hide-toolBar-header/deep/ .el-tabs__header {
  margin: 0 8px;
}
.back_icon:hover {
  cursor: pointer;
}
/* :root {
        --toolbar-width: 20vw;
    } */
.del {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 17px;
  right: 16px;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
}

.toolbar/deep/ .el-collapse-item__content {
  padding: 16px;
  box-sizing: border-box;
}
.toolbar/deep/ .el-collapse-item__header {
  padding: 0 24px;
  box-sizing: border-box;
}
/*.toolbar:not(.bigScreen-toolbar) {*/
.toolbar {
  overflow-y: auto;
  /*left: 90vw;*/
  width: 300px;
  box-shadow: 0 0 2px #aaa;
  box-sizing: border-box;
  background-color: white;
  z-index: 999;
  border-radius: 8px;
}
.toolbar /deep/ .size-inp-wrap {
  width: 39%;
}
.toolbar /deep/ .size-inp-wrap:not(:last-child) {
  margin-right: 6%;
}
.toolbar /deep/ .size-inp {
  /*width: calc(100% - 24px);*/
  height: 32px;
}
.toolbar-wh-row {
  margin-bottom: 20px;
}

.setting {
  display: flex;
  flex-direction: column;
}

.set-item {
  margin-bottom: 20px;
}

.toolbar-row-title {
  font-size: 14px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  margin: 0 0 12px 0;
  color: #1a173b;
}

.toolbar-position-inp,
.toolbar-size-inp {
  font-size: 14px;
  display: inline-block;
  position: relative;
  margin-right: 20px;
}

.toolbar-size-inp input,
.toolbar-position-inp input {
  width: 50px;
  display: inline-block;
  border: 1px solid #bfbfca;
  margin: 0 8px;
  line-height: 24px;
  padding: 0 12px;
  box-sizing: border-box;
}

.toolbar-size-inp input[disabled],
.toolbar-position-inp input[disabled] {
  border: 1px solid #dcdce7;
  color: #aaaaaa;
}

.position-lock-icon,
.size-lock-icon {
  position: absolute;
  bottom: 3px;
  right: 17px;
  cursor: pointer;
}

.size-lock-icon {
  bottom: 2px;
  right: -3px;
}

.toolbar-check-inp {
  color: #445477;
  font-size: 13px;
  width: 180px;
  display: inline-block;
  margin: 2px 0;
}

.toolbar-row-title + label {
  margin-top: 5px;
}

.toolbar-check-inp input {
  border: 1px solid #bfbfca;
}

.to-top-icon,
.to-bottom-icon {
  display: inline-block;
  margin-right: 10px;
  padding: 0 12px;
  height: 24px;
  text-align: center;
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
  background-color: #fff;
}

.optionName {
  width: 60px;
}
.toolbar {
  height: 100%;
  overflow-y: hidden;
}
.toolbar/deep/ .el-tabs .el-collapse-item__header {
  /*height: 36px;*/
  /*line-height: 36px;*/
  font-weight: 600;
  color: var(--textColor);
  position: relative;
  height: 34px;
  line-height: 34px;
  padding: 0 12px 0 30px;
}
.toolbar/deep/ .el-tabs {
  height: 100%;
}
.toolbar/deep/ .el-tabs__content::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.toolbar/deep/ .el-tabs__content {
  height: calc(100% - 88px);
  overflow-y: auto;
  padding: 0 0 50px 0;
  box-sizing: border-box;
  -ms-overflow-style: none; /* IE 10+ */
}
.toolbar/deep/ .el-tabs__content .el-collapse-item .el-collapse-item {
  border-top: none;
}
.toolbar/deep/ .el-collapse-item__content .el-collapse-item__content {
  padding: 0;
}
.toolbar/deep/ .el-collapse-item.paddingb_4 .el-collapse-item__content {
  padding-bottom: 4px;
}
/*设置面板的样式*/
.toolbar/deep/ .el-tabs__content .el-collapse-item {
  padding: 0;
  box-sizing: border-box;
  background-color: var(--elCollapseItemHeaderBgColor);
  /* border-top: 1px solid var(--borderColorEle); */
}
.stage-toolbar/deep/ .el-tabs__content .el-collapse-item {
  border-top: 1px solid #e9e9e9;
}
.toolbar .toolbar-header {
  background: #1f2124 !important;
  line-height: 38px;
  height: 38px;
  padding: 0 16px;
  color: var(--elCollapseItemHeaderColor);
  font-weight: 500;
  font-size: 15px;
  cursor: move;
}
.toolbar .toolbar-header {
  cursor: default;
}
.stage-toolbar .toolbar-header {
  background: #ecf1fa;
}
.toolbar .toolbar-header {
  cursor: default;
}
.toolbar/deep/ .el-tabs__header {
  margin: 0;
}
.toolbar/deep/ .el-tabs__item {
  font-size: 16px;
  line-height: 22px;
  padding: 0;
  /*color: rgba(0, 0, 0, 0.6);*/
  /*background: #f5f5f5;*/
}
.toolbar .el-collapse-item__content {
  background: var(--elCollapseItemWrapBgColor);
}
.toolbar/deep/ .el-tabs__item:hover {
  color: var(--elCollapseItemContentColor);
}

.toolbar/deep/ .el-tabs__item.is-active {
  font-weight: 500;
  font-size: 16px;
  /*color: rgba(0, 0, 0, 0.8);*/
}

.toolbar/deep/ .el-tabs__active-bar {
  width: 0 !important;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 8px solid #fff;
  content: "";
  position: absolute;
  left: 10px;
  bottom: -18px;
  background-color: var(--themeColor);
}
.toolbar/deep/ .el-tabs__nav {
  display: flex;
  float: none;
}
.toolbar/deep/ .el-tabs__nav-wrap::after {
  display: none;
}
.toolbar/deep/ .el-tabs__item {
  flex: 1;
  text-align: center;
  line-height: 48px;
  /*padding: 0 12px;*/
  height: auto;
}
.toolbar/deep/ .el-switch {
  width: 50px;
}
.toolbar/deep/ .switch-btn-group {
  border-radius: 4px;
  overflow-y: hidden;
  display: flex;
}
.toolbar/deep/ .switch-btn.active {
  background: var(--themeColor);
  font-size: 14px;
  color: #fff;
}
.toolbar/deep/ .switch-btn {
  display: inline-block;
  background: rgba(61, 130, 242, 0.1);
  padding: 6px 10px;
  font-size: 14px;
  line-height: 20px;
  color: var(--themeColor);
  width: 50%;
  text-align: center;
  cursor: pointer;
}
.toolbar/deep/ .title {
  position: relative;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.8);
}
.toolbar/deep/ .unfold-btn {
  width: 20px;
  height: 20px;
  background-image: url("../../../assets/images/arrows-up.png");
  transform: rotateY(90deg);
  position: absolute;
  top: 0;
  right: 0;
}
.toolbar/deep/ .fold-btn {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.toolbar/deep/ .shape-list .shape {
  width: 60px;
  text-align: center;
  cursor: pointer;
}
.toolbar/deep/ .shape-list .shape .shape-border {
  padding: 3px;
  border: 0.8px solid #e9e9e9;
  background: #ffffff;
  border-radius: 3.2px;
  margin-bottom: 8px;
  box-sizing: border-box;
}
.toolbar/deep/ .shape-list .shape .shape-border.select {
  border: 2px solid var(--themeColor);
}
.toolbar/deep/ .shape-list .shape img {
  width: 100%;
  height: 100%;
}
.toolbar/deep/ .shape-list .shape .shape-text {
  font-size: 12px;
  line-height: 17px;
  color: rgba(0, 0, 0, 0.6);
}
.bigScreen-toolbar.toolbar/deep/ .shape-list .shape .shape-text {
  color: rgba(255, 255, 255, 0.6);
}
.toolbar/deep/ .radius_bg_1 {
  width: 24px;
  height: 24px;
  background: url("../../../assets/images/radius_left_top.png");
}
.toolbar/deep/ .radius_bg_2 {
  width: 24px;
  height: 24px;
  background: url("../../../assets/images/radius_right_top.png");
}
.toolbar/deep/ .radius_bg_3 {
  width: 24px;
  height: 24px;
  background: url("../../../assets/images/radius_right_bottom.png");
}
.toolbar/deep/ .radius_bg_4 {
  width: 24px;
  height: 24px;
  background: url("../../../assets/images/radius_left_bottom.png");
}
.toolbar/deep/ .border-radius-header {
  position: relative;
  line-height: 30px;
}
.toolbar/deep/ .border-radius-btn {
  padding: 3px;
  border-radius: 4px;
  width: 62px;
  height: 30px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  cursor: pointer;
  background: var(--inputBackGround);
  box-sizing: border-box;
}
.toolbar/deep/ .border-radius-btn span {
  margin-left: 1px;
  width: 26.5px;
  height: 24px;
  display: inline-block;
  line-height: 24px;
  text-align: center;
  vertical-align: top;
  color: var(--thirdTextColor);
  border-radius: 3px;
}
.toolbar/deep/ .border-radius-btn span:first-child {
  margin-left: 0;
}
.toolbar/deep/ .border-radius-btn span:hover {
  background: var(--inputBackGround);
  color: var(--textColor);
}
.toolbar/deep/ .border-radius-btn span.select {
  background: var(--leftMenuBgColor);
  color: var(--themeColor);
}
.toolbar/deep/ .icon-portal-full-screen1.select::before {
  color: var(--themeColor);
}
.toolbar/deep/ .icon-portal-adjustment1.select::before {
  color: var(--themeColor);
}
.toolbar/deep/ .border-image {
  width: 200px;
}
/*.toolbar/deep/ .setting-item .content .upload {*/
/*  width: 160px;*/
/*  height: 90px;*/
/*}*/
/*.toolbar/deep/ .setting-item .content .upload {*/
/*  width: 108px;*/
/*  height: 90px;*/
/*}*/
.toolbar/deep/ .card {
  /*display: block;*/
  padding: 16px;
  background: #f7f7f7;
  border-radius: 4px;
  border: none;
}
.bigScreen-toolbar/deep/ .title14_32,
.bigScreen-toolbar/deep/ .title12_17,
.bigScreen-toolbar/deep/ .title14_20 {
  color: inherit;
}
.toolbar/deep/ .setting-item .ml24 {
  margin-left: 2px;
  margin-right: 10px;
}
.bigScreen-toolbar/deep/ .card {
  /*display: block;*/
  padding: 8px;
}
.toolbar/deep/ .common_btn_28_20 {
  padding: 5px 4px;
}
.toolbar/deep/ .card {
  background: var(--cardBgColor);
  padding: 16px;
}
.toolbar.card .el-slider__runway {
  background: var(--elCollapseItemWrapBgColor);
}
.toolbar/deep/ .custom-button-bg {
  display: inline-block;
  vertical-align: middle;
}

.toolbar/deep/ .card .repeat-style-ul > li {
  margin-right: 16px;
}
.toolbar/deep/ .repeat-style-ul > li {
  margin-right: 20px;
}
.toolbar/deep/ .card .repeat-style-ul > li {
  margin-right: 12px;
}
.toolbar/deep/ .el-collapse,
.toolbar/deep/ .el-collapse-item__wrap {
  border: none;
}
.toolbar/deep/ .el-collapse-item__header {
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  border: none;
}
.toolbar/deep/ .el-tabs .el-collapse-item__header .el-collapse-item__arrow {
  transform: rotate(0);
  color: rgba(255, 255, 255, 0.4);
  position: absolute;
  left: 12px;
}
.toolbar/deep/ .el-tabs .el-collapse-item__header > .el-collapse-item__arrow::before {
  content: "\e791";
}
.toolbar/deep/ .el-tabs .el-collapse-item__header > .el-collapse-item__arrow::before {
  content: "\e791";
}
.toolbar/deep/ .el-tabs .el-collapse-item__header .el-collapse-item__arrow.is-active {
  transform: rotate(90deg);
}
.toolbar/deep/ .el-tabs .el-collapse-item__header .el-collapse-item__arrow.is-active {
  transform: rotate(90deg);
}
/*设置面板的样式 end*/

.more-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--thirdTextColor);
  font-weight: 400;
}
.more-btn:hover {
  color: var(--themeColor);
}
.rect-active-slider {
  padding: 8px 12px;
}
</style>
